module.exports = __webpack_public_path__ + "mediamarkt.png?12ff29f191c3b8a7074cd661c50baee5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mediamarkt.png
// module id = 981
// module chunks = 2